'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'alarm-clock';
var width = 512;
var height = 512;
var aliases = [9200];
var unicode = 'f34e';
var svgPathData = ['M48 288a208 208 0 1 0 416 0 208 208 0 1 0 -416 0zM248 160l16 0 0 140.2 77 61.6 6.2 5-10 12.5-6.2-5-80-64-3-2.4 0-147.8z', 'M362.4 37.6c-5.3-2.3-10.7-4.4-16.2-6.3 17.4-19.2 42.6-31.3 70.6-31.3 52.6 0 95.2 42.6 95.2 95.2 0 21.8-7.3 41.9-19.7 58-2.9-5-5.9-10-9.1-14.8 8.1-12.4 12.8-27.3 12.8-43.2 0-43.8-35.5-79.2-79.2-79.2-21 0-40.2 8.2-54.4 21.6zM19.7 153.2c-12.3-16.1-19.7-36.2-19.7-58 0-52.6 42.6-95.2 95.2-95.2 28 0 53.2 12.1 70.6 31.3-5.5 1.9-10.9 4-16.2 6.3-14.2-13.4-33.3-21.6-54.4-21.6-43.8 0-79.2 35.5-79.2 79.2 0 15.9 4.7 30.8 12.8 43.2-3.2 4.8-6.2 9.8-9.1 14.8zM464 288a208 208 0 1 0 -416 0 208 208 0 1 0 416 0zM408.6 451.9C368.6 489.2 315 512 256 512s-112.6-22.8-152.6-60.1l-1.7 1.7-56 56-5.7 5.7-11.3-11.3 5.7-5.7 56-56 1.7-1.7C54.8 400.6 32 347 32 288 32 164.3 132.3 64 256 64S480 164.3 480 288c0 59-22.8 112.6-60.1 152.6l63.4 63.4-11.3 11.3-63.4-63.4zM264 168l0 132.2 77 61.6 6.2 5-10 12.5-6.2-5-80-64-3-2.4 0-147.8 16 0 0 8z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faAlarmClock = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;